<template>
  <div>
    <b-form @submit.prevent="submit" @reset="onReset">

      <b-form-group>
        <label>Name*</label>
        <b-form-input
          placeholder="new_category"
          v-model="form.name"
        />
      </b-form-group>

      <b-form-group>
        <label>Display name*</label>
        <b-form-input
          placeholder="New category"
          v-model="form.display_name"
        />
      </b-form-group>

      <b-form-group>
        <label>Parent category</label>
        <multiselect
          v-model="form.parent"
          :options="parentCategories"
          placeholder="Parent category"
          track-by="id"
          label="name"
          :allow-empty="false"
          :showLabels="false"
        ></multiselect>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox v-model="form.is_project_related" value="1" unchecked-value="0">
          Project related
        </b-form-checkbox>
      </b-form-group>

      <b-form-group>
        <label>Comment*</label>
        <b-form-textarea
          id="textarea"
          v-model="form.comment"
          placeholder="Enter comment"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group v-if="edit">
        <!-- <b-button @click="close" variant="danger">Close</b-button> -->
        <b-button
          type="submit"
          :disabled="isButtonDisabled"
          variant="outline"
          class="ml-auto button"
        >
          Edit
        </b-button>
      </b-form-group>
      <b-form-group v-else>
        <div class="d-flex">
          <b-button
            variant="outline"
            class="ml-auto button"
            type="reset"
          >
            Reset
          </b-button>
          <b-button
            type="submit"
            :disabled="isButtonDisabled"
            class="button"
            variant="primary"
          >
            Create
          </b-button>
        </div>

      </b-form-group>
    </b-form>
    <div class="preloader" v-if="showPreloader && isLoading">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FinancesExpensesCategoryForm',
  data () {
    return {
      locParentCategories: [],
      form: {
        name: '',
        display_name: '',
        parent_id: '',
        parent: {},
        is_project_related: 0,
        comment: ''
      }
    }
  },
  props: {
    edit: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String
    },
    dataProps: {
      type: Object,
      default: () => {}
    },
    name: {
      type: String
    },
    display_name: {
      type: String
    },
    parentCategories: {
      type: Array
    },
    modal: {
      type: Boolean
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    showPreloader: {
      type: Boolean,
      default: () => false
    }
  },
  mounted () {
    this.locParentCategories = this.parentCategories

    if (this.edit) {
      this.setData()
    }
  },
  computed: {
    isButtonDisabled () {
      // eslint-disable-next-line
                return !this.form.name || !this.form.display_name || !this.form.comment || this.isLoading;
    }
  },
  methods: {
    setData () {
      this.form.name = this.dataProps.name
      this.form.display_name = this.dataProps.display_name_original || this.dataProps.display_name

      this.form.parent = this.locParentCategories.find(
        item => item.id === this.dataProps.parent_id
      )

      this.form.is_project_related = this.dataProps.is_project_related
      this.form.comment = this.dataProps.comment
    },
    onReset (evt) {
      if (evt) {
        evt.preventDefault()
      }

      /* Reset our form values */
      for (let key in this.form) {
        this.form[key] = ''
      }
      /* Trick to reset/clear native browser form validation state */
      this.$nextTick(() => {
        this.show = true
      })
    },
    close () {
      this.$emit('close')
      this.onReset()
    },
    submit () {
      const payload = {
        name: this.form.name,
        display_name: this.form.display_name,
        parent_id: this.form.parent ? this.form.parent.id : null,
        is_project_related: this.form.is_project_related,
        comment: this.form.comment
      }
      if (this.isButtonDisabled) {
        return
      }
      this.$emit('submit', payload)
    }
  }
}
</script>

<style lang="scss" scoped>
  .custom-form {
    position: relative;
    padding: 20px 30px;
  }
  .preloader{
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 10;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.7);
  }
</style>
